<script lang="ts">
  import TreeView from 'svelte-tree-view'
  export let data:unknown
</script>

<TreeView data={data} class={`${$$props.class || ''} typed-tree-view`}/>

<style>
  :global(.typed-tree-view) {
    --tree-view-base00: #002b36;
    --tree-view-base01: #073642;
    --tree-view-base02: #586e75;
    --tree-view-base03: #657b83;
    --tree-view-base04: #839496;
    --tree-view-base05: #93a1a1;
    --tree-view-base06: #eee8d5;
    --tree-view-base07: #fdf6e3;
    --tree-view-base08: #dc322f;
    --tree-view-base09: #cb4b16;
    --tree-view-base0A: #b58900;
    --tree-view-base0B: #859900;
    --tree-view-base0C: #2aa198;
    --tree-view-base0D: #268bd2;
    --tree-view-base0E: #6c71c4;
    --tree-view-base0F: #d33682;
	}
  </style>